import { InputText } from 'primereact/inputtext';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { DARK_NAVY_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';

export const SearchBoxContainer = styled.div`
    display: 'flex';
    justify-content: space-between;
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    color: ${DARK_NAVY_FONT_COLOR};
    margin: ${({marginDesktop}) =>
        marginDesktop ? marginDesktop : '15px 15px'};
    background: ${({ background }) =>
        background ? background : '#ffffff 0% 0% no-repeat padding-box'};

    align-items: center;
    ${media.mobileDevice`                   
            margin: ${({margin}) =>
                margin ? margin : 'auto 15px 0px 15px'};
            display: 'flex';
            width: ${({containerMobileWidth}) =>
                containerMobileWidth
                    ? containerMobileWidth
                    : '100%'};
    `}
    ${media.mediumDevice`
        margin: ${({marginIpad}) => marginIpad ? marginIpad : ''};
        `
    }
`;

export const StyledSpan = styled.span`
    width: ${({ isPopUp, isCalendar, width }) =>
        isPopUp || isCalendar ? width : '100%'};
    display: inline-block;
`;

export const StyledI = styled.i.attrs(() => ({
    className: 'pi pi-search',
}))`
    font-size: ${({ isCalendar, isPopUp }) =>
        isCalendar || isPopUp ? 'larger !important' : '1rem'};
    opacity: ${({ isCalendar, isPopUp }) =>
        isCalendar || isPopUp ? '0.4' : '1'};

    .p-input-icon-left > i,
    .p-input-icon-right > i {
        margin-top: ${({ isCalendar, isPopUp }) =>
            isCalendar || isPopUp ? '-0.6rem !important' : '-0.5rem'};
    }

    /* ${media.mobileDevice`       

  ::before {
  float: right;
  padding-right: 10px;
  }
      
  `} */
`;

export const StyledInputText = styled(InputText)`
    &::placeholder {
        margin-left: ${({ placeholderMarginLeft }) =>
            placeholderMarginLeft ? placeholderMarginLeft : '0px'};
        /* Or use padding-left if you want the text itself to shift */
        padding-left: ${({ placeholderPaddingLeft }) =>
            placeholderPaddingLeft ? placeholderPaddingLeft : '0px'};
        font-weight: ${({ placeholderFontWeight }) =>
            placeholderFontWeight ? placeholderFontWeight : 'normal'};
    }
    
    ${media.mobileDevice`
        color: ${DARK_NAVY_FONT_COLOR};
    `}
`;
